import { createApp } from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import App from './App.vue';
import { router } from './router';
import { setUnauthorizedHandler } from './api/client';
import { bootstrapSession } from './store/bootstrap';
import './style.css';

setUnauthorizedHandler(() => {
  router.replace({ name: 'login', query: { next: router.currentRoute.value.fullPath } });
});

// 先完成会话初始化（含票据换 token）再挂载，避免首屏闪一下登录页
bootstrapSession().finally(() => {
  createApp(App).use(router).use(Vant).mount('#app');
});
